import { render, staticRenderFns } from "./AgreementDecorteModal.vue?vue&type=template&id=2d24c5d3&scoped=true&lang=pug&"
import script from "./AgreementDecorteModal.vue?vue&type=script&lang=ts&"
export * from "./AgreementDecorteModal.vue?vue&type=script&lang=ts&"
import style0 from "./AgreementDecorteModal.vue?vue&type=style&index=0&id=2d24c5d3&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d24c5d3",
  null
  
)

export default component.exports